// The auth pages' own tiny root — shared verbatim between server prerender
// (authServer.ts) and client hydration (authClient.ts), same discipline as
// AppRoot.ts. Deliberately NOT mounted inside Shell.ts: a signed-out visitor
// on /login or /signup has no mini-app sidebar to show, and Shell.ts's own
// "Sign in" link is how a signed-out visitor gets to /login in the first
// place — wrapping this in the shell that sends them here would be
// circular. A real (if tiny) Router, not two separate roots: /login and
// /signup share one root and one client bundle now that there are two
// pages, the same reason AppRoot.ts uses one Router for its own mini-apps
// rather than a Root per mini-app.
import { h } from 'preact';
import { LocationProvider, ErrorBoundary, Router, Route } from 'preact-iso';
import { LoginPage } from './LoginPage.js';
import { SignupPage } from './SignupPage.js';

// Takes a (currently unused) wide props param, not none — see appServer.ts's
// matching comment on AppRoot: h()'s generic infers from whatever parameter
// type the component declares, and a zero-arg component infers `never`,
// which prerender()/hydrate()'s own VNode<{}> expectation cannot widen back
// to.
export function AuthRoot(_props: Record<string, unknown>) {
  return h(LocationProvider, null,
    h(ErrorBoundary, null,
      h(Router, null,
        h(Route, { path: '/login', component: LoginPage }),
        h(Route, { path: '/signup', component: SignupPage }),
      ),
    ),
  );
}
